// extracted by mini-css-extract-plugin
module.exports = {"permissionElement":"Permissions-module__permissionElement--3ikxJ","permissionIcon":"Permissions-module__permissionIcon--2nBM_"};